import { render } from "./ManageChannel.vue?vue&type=template&id=7600a301"
import script from "./ManageChannel.vue?vue&type=script&lang=js"
export * from "./ManageChannel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__